import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import {colores, globales,funciones}                                from '../../global';
import BarraBotones                                                 from '../../components/Barra_menu';
import AuthService                                                  from '../../AuthService';
import Request                                                      from 'superagent';
import CustomTable                                                  from '../../components/CustomTable';
import {Table}                                                      from '@devexpress/dx-react-grid-material-ui';
import TableRowsIndexer                                             from '../../components/tableRowsIndexer'
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Backdrop                                                     from '@material-ui/core/Backdrop';
import { Typography,TextField }                                     from '@material-ui/core';
import Reporte                                                      from '../../components/Modalreporte';
import Paper                                                        from '@material-ui/core/Paper';
import Autocomplete                                                 from '@material-ui/lab/Autocomplete';

let Auth = new AuthService();
var ip=globales.ip
var border_dialog=globales.border_dialog
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let isVisibleRowSelected = false;
//const colorRowSelected =  'rgb('+ colores.tabla.selection +')';
//let alternateColorRow1 = colores.tabla.alternateColorRow1; 
//let alternateColorRow2 = colores.tabla.alternateColorRow2;

const getRowId = row => row.ID_SECCION;

/*                           CLASES DE ESTILO                       */

var styles = theme =>({
    Dialog:{
        borderRadius: border_dialog,
        margin:0,
        padding:0
    },
    backdrop: {
      zIndex: 500000,
      color: '#fff', 
      flexDirection: 'column'
    },
    select: { //CONFIGURA EL SELECT 
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'50%',
      },
      textField: {
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
        width: '20%'      
      },
  
    })

    const columns= [
        {name:'ID_SECCION',title: 'ID_SECCION'}
        ,{name:'CODIGO_CURSO',title: 'Código'}
        ,{name:'DESCRIPCION_CURSO',title: 'Descripción'}
        ,{name:'INICIO',title: 'Inicio'}
        ,{name:'FIN',title: 'Fin'}
        ,{name:'SECCION',title: 'Sección'}
        ,{name:'CODIGO',title: 'Aula'}
        ,{name:'JORNADA',title: 'Jornada'}
        ,{name:'MODALIDAD',title: 'Grupo'}
        ,{name:'CANTIDAD',title: 'Cantidad'}
        ,{name:'ANIO_PERIODO',title: 'ANIO_PERIODO'}
      ];
  
      const defaultHiddenColumnNames= ['ID_SECCION','ANIO_PERIODO'];
  
      const tableColumnExtensions= [
          { columnName: 'CODIGO_CURSO', wordWrapEnabled: false, align: 'center',width: 150},
          { columnName: 'DESCRIPCION_CURSO', wordWrapEnabled: false, align: 'center' ,width: 420},
          { columnName: 'INICIO', wordWrapEnabled: false, align: 'center',width: 120},
          { columnName: 'FIN', wordWrapEnabled: false, align: 'center',width: 120},
          { columnName: 'SECCION', wordWrapEnabled: false, align: 'center',width: 120},
          { columnName: 'CODIGO', wordWrapEnabled: false, align: 'center',width: 150},
          { columnName: 'JORNADA', wordWrapEnabled: false, align: 'center',width: 150},
          { columnName: 'MODALIDAD', wordWrapEnabled: false, align: 'center',width: 150},
          { columnName: 'CANTIDAD', wordWrapEnabled: false, align: 'center',width: 110},
      ];


/*                                        EXPORT                                      */
export default withStyles(styles)(
    class EstudiantesMatriculados extends React.Component {
      tablaRef = React.createRef();
      descripcionRef = React.createRef();

      constructor(props) {
        super(props);
        this.l= props.l
        this.e= props.e
        this.i= props.i
        this.isVisibleRowSelected=isVisibleRowSelected
        this.actualizarbarra=props.actualizarbarra
        this.actualizarcircular=props.actualizarcircular

        this.state = {
            openBackDrop:      false, 
            isLoggin:          undefined,
            heightTableMain:    0,
            rows: [],
            selection: [],
            grouping: [],
            expandedGroups: [],
            filteringColumnExtensions: [],
            filters: [],
            expandedRowIds: [],
            enabledFilterRows: true,
            selection_row:  [],
            vobtenerdescripcion:'',
            loadingMain: false,

            optionsPeriodos: [],
            valuePeriodos: [],
            loadingPeriodos: true

        }

        const RenderOption = ((option) => {
          return (
            <div style={{ lineHeight: 1.9,width: "100%"}}>
            { option.PERIODO }{' ('}<li style={{ fontWeight:"bold" ,textAlign: "center", display: " inline-block"}}>{ option.DESCRIPCION }</li>{')'}
            </div>
          );
        });

          const VirtualTable_cellComponent = (getTime) => (props) => {
            const { column }    = props;
            const {row}         = props;
        
            if (column.name === 'INICIO')
          {
            return ( <Table.Cell {...props} style={{padding: 0, height:'8px',}}>
                      { row.INICIO !== null ? getTime(row.INICIO, 1) : row.INICIO }
                    </Table.Cell>);
          }
        
          if (column.name === 'FIN')
          {
            return ( <Table.Cell {...props} style={{padding: 0, height:'8px',}}>
                      { row.FIN !== null ? getTime(row.FIN, 1) : row.FIN }
                    </Table.Cell>);
          }
          
        return(
            <Table.Cell {...props}
            
            />
          );
        } 


        this.VirtualTable_cellComponent = VirtualTable_cellComponent; 
        this.RenderOption=RenderOption;
   
        
    }; //FIN CONSTRUCTORS


changeSelection = (selection) =>{
    if(selection[selection.length-1]===undefined)
    {
        this.setState({ selection: this.state.selection});
    }
    else
    {
     this.state.rows.forEach(element => {
        if(element.ID_SECCION===funciones.getIdRowChecking(selection,this.state.selection))
        {
            this.setState({selection: [selection[selection.length-1]],selection_row:[{ID_SECCION: element.ID_SECCION}]})
        }
      });
       
    }
 }

  onChangeAutocomplete = (event, newValue)=>
  {
    this.setState({ rows: [],valuePeriodos:newValue}, ()=>{  

      if (newValue === null)
      {
          return;
      }
      else
      {
        this.setState({ loadingMain: true }, ()=>{
        this.obtener_cursos(newValue.ID_CONTROL_MATRICULA);
        });
      }

    });
     
  }


 generarreporte=event=>{
    if(this.state.selection.length!==0)
    document.getElementById("BT-ListaMatriculadosCat").click();

 }

 obtener_cursos= (id_control_matricula)=>{
 new Request.get(`${ip}/estudiantesmatriculados/obtener_cursos_catedratico/${id_control_matricula}/${Auth.getProfile().user}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(0)
  .timeout({ response: 20000, deadline: 50000, }) 
  .end((err, res)=> {
   if (err) { 
          if (err.toString().substr(0,16) === 'Error: Forbidden')
          {
            window.location.reload();
            return;  
          }
          (async function() {
              funciones.showToast('e','Error de conexión')
          })();//FIN FUNCION ASYNC
          return;
  }
  const tmp = JSON.parse(res.text);
  if(tmp.length>0)
  {
    this.setState({ rows: tmp,loadingMain: false}); 
  }
  else
  {   
    this.setState({rows: [], heightTableMain:funciones.getHeightTableMain(movil_pequeño,this).heightTable,loadingMain: false})
  }
  
  this.actualizarbarra(true)
})

}


componentDidMount()
{
        let _this = this;
        _this.actualizarbarra(false)

        /*Auth.loggedIn().then( function(b){
            _this.setState({ isLoggin: b})
            if(b)*/
            this.setState({ isLoggin: Auth.getProfile().plataforma !== undefined ? true : false }, ()=>{
            this.setState({heightTableMain: funciones.getHeightTableMain(movil_pequeño,_this).heightTable})

/*********************************************************************************************************************************/
          Request.get(`${ip}/estudiantesmatriculados/obtener_periodo_activo_calificador/${Auth.getProfile().user}`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(1)
            .timeout({ response: 20000, deadline: 50000, }) 
            .end((err, res)=> {
             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      window.location.reload();
                      return;  
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión periodo')
                    })();//FIN FUNCION ASYNC
                    return;
            }
            const tmp = JSON.parse(res.text);
            if(tmp.length>0){
              this.setState({optionsPeriodos:tmp,loadingPeriodos: false,
              valuePeriodos:{ID_CONTROL_MATRICULA: tmp[0].ID_CONTROL_MATRICULA, PERIODO: tmp[0].PERIODO, DESCRIPCION:tmp[0].DESCRIPCION}})
             
              this.obtener_cursos(this.state.valuePeriodos.ID_CONTROL_MATRICULA)    
            }
           
            _this.actualizarbarra(true)
            })

        })
}

/*                                          RENDER                          */
render() {
    const { classes } = this.props;

    const botones = [
        {icono: 'Print', toolt: 'Imprimir', nombre: 'Imprimir' ,escritura:true , disabled:this.state.selection.length===0 ,onclick: this.generarreporte
        ,  display: 'auto'},
      ]

    if (this.state.isLoggin === true )
    {
    return (    
    <React.Fragment>
      <Backdrop className={classes.backdrop}  open={this.state.openBackDrop}>
          <CircularProgress color="inherit" />
          <span style={{ marginTop: '10px' }}>{this.state.open_seleccion?'Guardando...':this.state.open_borrar?'Eliminando...':''}</span>
      </Backdrop>

      
      <Reporte id="BT-ListaMatriculadosCat" 
        parametros={this.state.selection_row[0]!==undefined?this.state.vobtenerdescripcion.toString()+','+ this.state.selection_row[0].ID_SECCION.toString():''}
        nom_boton="Imprimir" nom_bar="Lista de Matriculados" 
        label_reporte={'LISTAMATRICULADOS'}
        backcolor={colores.azul} fill={'white'} fullScreen={true} boton={false}  color="primary" color_bar='primary'
        opciones={false}/>
     
      <div align="left" style={{marginLeft:movil_pequeño?1:20,marginBottom: 10,marginTop: 25,display:"flex"}}>
      <Typography align='left' style={{fontWeight:'bold',fontSize:15}} >
        Periodo:   
      </Typography> 

      <Autocomplete
        id="periodos"
        options={this.state.optionsPeriodos}
        getOptionLabel={(option) =>  option.PERIODO +' (' + option.DESCRIPCION + ')' }
        style={{ marginTop: movil_pequeño?5:-15,marginLeft:5, width: !movil_pequeño ? '230px' : '100%'}}
        renderInput={(params) => <TextField {...params} 
                                    label="Periodos"
                                    variant="outlined" 
                                    InputProps={{...params.InputProps,
                                                endAdornment: (
                                                  <React.Fragment   >
                                                    {this.state.loadingPeriodos ? <CircularProgress size={18} /> : null}
                                                    {params.InputProps.endAdornment}
                                                  </React.Fragment>
                                                ),
                                              }}
                                    fullWidth
                                   />}
        renderOption={this.RenderOption}
        onChange={this.onChangeAutocomplete}                                  
        loading={this.state.loadingPeriodos}
        value={this.state.valuePeriodos}
        PaperComponent={(props)=>(<Paper elevation={12} {...props} />)}  
        openOnFocus={true}                    
      />

      </div>
      {/* COLUMNA DESCRIPCION */}
 
      <div align="left" style={{marginLeft:movil_pequeño?1:20,marginBottom: 5,marginTop: 20, display: movil_pequeño?"block":"flex"}}>
        <Typography align='left' >
         Descripción Columna en Reporte:  
        </Typography>
       
        <TextField 
          style={{marginTop: movil_pequeño?5:-5,marginLeft:5, width:movil_pequeño?'98%':'20%'}}
          variant="outlined"  
          id="descripcion" label="Descripción" name="descripcion" 
          fullWidth={movil_pequeño}
          onChange={event => {this.setState({vobtenerdescripcion: event.target.value});}}
        />
        </div>
       
      {/*------------------- */}
      {/*--BOTON DE IMPRIMIR */}

      <div style={{marginLeft:movil_pequeño?1:20,marginBottom:5,marginTop:5 ,display: movil_pequeño?"block":"flex",}}>
        <Typography align='left'>
         Debe de Marcar una Clase y luego Presionar el Botón de Impresión:
        </Typography>
        <div style={{marginLeft: movil_pequeño?'0%':'22%',boder:'none'}}>
            <BarraBotones   align='center' botones={botones} l={this.l} e={this.e} i={this.i}/> 
        </div>
      </div> 
       {/*------------------- */}
      <div ref={this.tablaRef} style={{background:'white',marginLeft:movil_pequeño?globales.tabla.marginleft_movil:globales.tabla.marginleft,marginRight:movil_pequeño?globales.tabla.marginright_movil:globales.tabla.marginright}}>
        <CustomTable
            Columns={columns}                                    
            Rows={this.state.rows}                                          
            TableColumnExtensions={tableColumnExtensions}
            DefaultHiddenColumnNames={defaultHiddenColumnNames}
            getRowId = {getRowId}
            Selection={this.state.selection}
            ChangeSelection = {this.changeSelection}
            height={this.state.heightTableMain===0?120:this.state.heightTableMain-120}
            //Filters = {this.state.filters}
            //onFiltersChange = {this.changeFilters}
            //ExpandedGroups = {this.state.expandedGroups}
            //ExpandedRowIds = {this.state.expandedRowIds}
            loading={this.state.loadingMain} 
            enabledFilterRows= {this.state.enabledFilterRows}
            standarPlugin = { <TableRowsIndexer/> }
            VirtualTable_cellComponent={this.VirtualTable_cellComponent(funciones.getTime)}
            showSelectionColumn={true}
            RowComponent={this.trow}

        />
      </div>
    </React.Fragment>
    ); /// finaliza return
    }
    else if (this.state.isLoggin === false)
    {
        Auth.logout()
        window.location.reload();
        return; 
    }


    return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles
